import React, { useContext } from 'react';
import {
  HeaderName,
  HeaderGlobalBar,
  HeaderGlobalAction,
  SkipToContent,
} from 'carbon-components-react/lib/components/UIShell';

import Close20 from '@carbon/icons-react/lib/close/20';
import Help20 from '@carbon/icons-react/lib/help/20';

import { UIShellContext } from '../../contexts/UIShellContext';

const UIShellHeader = () => {
  const { showSideMenuRightHelp, toggleShowSideMenuRightHelp } = useContext(
    UIShellContext
  );

  const handleClickHeaderHelp = () => {
    toggleShowSideMenuRightHelp(!showSideMenuRightHelp);
  };

  return (
    <React.Fragment>
      <SkipToContent />
      <div className="UIShell-header-titel">
        <HeaderName prefix="IBM">CIRCA</HeaderName>
      </div>

      <HeaderGlobalBar>
        <HeaderGlobalAction aria-label="Help" onClick={handleClickHeaderHelp}>
          {showSideMenuRightHelp ? <Close20 /> : <Help20 />}
        </HeaderGlobalAction>
      </HeaderGlobalBar>
    </React.Fragment>
  );
};

export default UIShellHeader;
